import {
  VISUALITZACIO_INICIALITZAR,
  VISUALITZACIO_OMPLIR_DATA_SELECCIONADA
} from "../../actions/actionTypes";
import { MASCARA_ISO_DIA, textAMoment } from "../../utils/dates";

const ESTAT_INICIAL = "";

const dataSeleccionada = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case VISUALITZACIO_INICIALITZAR:
      return ESTAT_INICIAL;

    case VISUALITZACIO_OMPLIR_DATA_SELECCIONADA:
      return action.payload.format(MASCARA_ISO_DIA);

    default:
      return state;
  }
};

export default dataSeleccionada;
export const getDataSeleccionada = state => state.dataSeleccionada;
export const getDataSeleccionadaAsMoment = state =>
  textAMoment(state.datadataSeleccionada, MASCARA_ISO_DIA);
